import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import { get, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import nav4 from "../../../assets/images/nav4.svg";
import camera from "../../../assets/images/camera.png";
import avatar from "../../../assets/images/personPlaceholder.png";

const GymSettings = () => {
  document.title = "Gym Settings | Elevated - Admin Dashboard";
  const userId = localStorage.getItem("userId");
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    profileImage: "",
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        if (userId) {
          const response = await get(`${endpoints.user}/${userId}`);
          if (response?.status === 200 && response?.data?.data) {
            setProfileData(response?.data?.data);
          } else {
            // toast.error("Failed to load profile data");
          }
        }
      } catch (error) {
        toast.error("Error fetching profile data");
      }
    };

    fetchProfileData();
  }, [userId]);

  const handleUpdateProfile = async (values) => {
    const [firstName, lastName] = values.fullName.split(" ");
    const updatedData = {
      firstName,
      lastName,
      email: values.email,
      phoneNumber: values.phoneNumber,
    };

    try {
      const response = await put(`${endpoints.user}/${userId}`, updatedData);
      if (response?.status === 200) {
        toast.success("Profile Updated Successfully", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });

        const updatedResponse = await get(`${endpoints.user}/${userId}`);
        setProfileData(updatedResponse?.data?.data);
        setIsEditing(false);
      } else {
        toast.error("Failed to update profile");
      }
    } catch (error) {
      toast.error("Error updating profile");
    }
  };

  return (
    <Card className="rounded-4" sstyle={{ height: "550px" }}>
      <CardBody>
        <Row className="g-0">
          <Col xs="12">
            <h2 className="card-title fw-bold ff-sora font-size-20 primary-black">
              Gym/Club Settings
            </h2>
            <span className="ff-sora secondary-black fw-normal font-size-16">
              Profile Media
            </span>
          </Col>
        </Row>
        <Row className="g-0">
          <Col xs="12" className="mb-3">
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={
                  profileData?.additionalInfo?.profileImage
                    ? `${process.env.REACT_APP_IMG_URL}${profileData?.additionalInfo?.profileImage}`
                    : avatar
                }
                alt="Profile"
                className="object-fit-cover"
                height={240}
                width={360}
                style={{
                  borderRadius: "12px",
                }}
              />
              <span
                className="position-absolute font-size-14 "
                style={{
                  right: "10px",
                  top: "10px",
                  padding: "5px",
                  borderRadius: "12px",
                }}
              >
                <img src={camera} alt="Camera Icon" />
              </span>
            </div>
          </Col>
        </Row>

        <Row className="g-0">
          <div>
            <h6 className="fw-normal secondary-black font-size-16 mb-3 ff-sora">
              General Info
            </h6>
            <Formik
              initialValues={{
                fullName: `${profileData.firstName} ${profileData.lastName}`,
                email: profileData.email,
                phoneNumber: profileData.phoneNumber || "NA",
              }}
              enableReinitialize
              onSubmit={(values) => handleUpdateProfile(values)}
            >
              {({ values, handleChange }) => (
                <Form>
                  <Row className="align-items-center g-0">
                    <Col
                      md="5"
                      className="light-black font-size-16 ff-sora fw-normal"
                    >
                      <p>Name</p>
                      <p>Email</p>
                      <p>Phone No.</p>
                    </Col>
                    <Col
                      md="6"
                      className="secondary-black font-size-16 ff-sora fw-normal"
                    >
                      {isEditing ? (
                        <>
                          <Field
                            as={Input}
                            type="text"
                            name="fullName"
                            value={values.fullName}
                            onChange={handleChange}
                            className="mb-2"
                          />
                          <Field
                            as={Input}
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            className="mb-2"
                          />
                          <Field
                            as={Input}
                            type="phoneNumber"
                            name="phoneNumber"
                            value={values.phoneNumber}
                            onChange={handleChange}
                          />
                        </>
                      ) : (
                        <>
                          <p>
                            {profileData.firstName} {profileData.lastName}
                          </p>
                          <p>{profileData.email}</p>
                          <p>{profileData.phoneNumber}</p>
                        </>
                      )}
                    </Col>
                  </Row>
                  {isEditing && (
                    <Row className="g-0">
                      <Col xs="12" className="mt-3 text-end">
                        <Button type="submit" className="rounded-pill">
                          Update Profile
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Row>

        {!isEditing && (
          <Row className="g-0">
            <Col xs="12" className="mt-3 text-end">
              <Button
                onClick={() => setIsEditing(true)}
                className="rounded-pill"
              >
                Edit Profile
              </Button>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default GymSettings;
